import React from 'react';

import sadderSquonk from 'assets/sadderSquonk.svg';
import { useTranslation } from 'react-i18next';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: { margin: theme.spacing(2) },
    image: { maxWidth: 'min(100%, 10rem)' },
  }),
);

const NotFoundPage = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <img className={styles.image} src={sadderSquonk} alt={t('sad_squonk_alt')} />
      <p>{t('page_not_found')}</p>
    </div>
  );
};

export default NotFoundPage;
